var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFivePublic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.331 3.462v-2.46h-7.207L7.274 4.8V11h3.85V7.194h7.207V4.801h-7.207V3.462h7.207Z",
  fill: "#5956A5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.124 1.001v3.8h-3.85l3.85-3.8ZM27.948 1.001H20.28V11h3.844V7.827h3.823c3.681 0 4.777-1.524 4.777-3.326v-.214c0-1.83-1.056-3.287-4.777-3.287v.001Zm.813 3.433c0 .548-.393.908-1.273.908h-3.363V3.486h3.363c.906 0 1.273.333 1.273.908v.04Z",
  fill: "#ECEDEC"
})));
export default SvgFivePublic;